module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACKSURBVHgB7dDRDYAgDEXRN4IjOIIjdgRHcANHYBRHcIQKsSaESKDR8tWT8OfjGgDnnPsbMy/xhHhmKMXNJNtFO0zRk2+HJp6+lQ3LHf1x+dtcV7yIPgJ6yVPtmngluqW7oCXDZrwWxRetuEm0FTeNZvH1JW4bzeLEdQRLlThhhCJOGEniBOecG+0CPNySddAY0uYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/down.png
// module id = ZlxF
// module chunks = 34